import { TrackTile } from './TrackTile.js';

import type { ReactElement } from 'react';

type TrackRowProps = {
  readonly title: string;
  readonly artist?: string;
  /** Sits after the artist and is never truncated — a countdown that reads "in 2…" says nothing. */
  readonly meta?: string;
  readonly colour: string | undefined;
  readonly imageUrl: string | null;
  readonly size?: number;
  readonly titleClassName?: string;
  readonly artistClassName?: string;
  readonly stackClassName?: string;
};

/** The tile plus the truncated title/artist stack beside it — the part every
 * accent-card track row shares. Callers own the surrounding flex row and any
 * trailing meta, since those differ by page. */
export const TrackRow = ({
  title,
  artist,
  meta,
  colour,
  imageUrl,
  size,
  titleClassName = 'text-content truncate text-sm font-medium',
  artistClassName = 'text-muted truncate text-xs',
  stackClassName = 'min-w-0 flex-1',
}: TrackRowProps): ReactElement => (
  <>
    <TrackTile
      title={title}
      colour={colour}
      {...(size === undefined ? {} : { size })}
      imageUrl={imageUrl}
    />
    <div className={stackClassName}>
      <p className={titleClassName}>{title}</p>
      {artist === undefined && meta === undefined ? null : (
        <p className="flex items-baseline gap-1">
          {artist === undefined ? null : (
            <span className={`min-w-0 ${artistClassName}`}>{artist}</span>
          )}
          {meta === undefined ? null : (
            <span className="text-muted shrink-0 text-xs whitespace-nowrap">· {meta}</span>
          )}
        </p>
      )}
    </div>
  </>
);
